<script lang="ts" module>
	export let inputColorClasses =
		'rounded-md bg-violet-50 border border-violet-300 text-violet-900 placeholder:text-violet-300 focus:border-violet-500 focus:ring-violet-500 outline-violet-500 appearance-none leading-tight ';
	export let inputPaddingClasses = 'py-3 px-4';
	export let inputShadowClasses = 'shadow-sm';
	export let inputClasses = inputColorClasses + ' ' + inputPaddingClasses + ' ' + inputShadowClasses;
</script>

<script lang="ts">
	import { onMount, type Snippet } from 'svelte';
	import type { HTMLTextareaAttributes } from 'svelte/elements';
	import IconExpand from '~icons/material-symbols/expand-content-rounded';
	import IconCollapse from '~icons/material-symbols/collapse-content-rounded';

	type Props = {
		value?: string | undefined | null;
		error?: string[] | undefined;
		trim?: boolean;
		id?: string;
		left?: Snippet;
		right?: Snippet;
		class?: string;
		rows?: number;
	} & HTMLTextareaAttributes;

	let {
		value = $bindable(undefined),
		error = $bindable(undefined),
		trim = true,
		id = '',
		left,
		right,
		class: classes,
		rows = 1,
		...restProps
	}: Props = $props();

	let isExpanded = $state(false);
	let hasScrollbar = $state(false);
	let textarea = $state<HTMLTextAreaElement>();
	function onblur() {
		if (trim) {
			value = value?.trim();
		}
	}

	onMount(() => {
		checkScrollbar();
	});

	function checkScrollbar() {
		hasScrollbar = textarea!.scrollHeight > textarea!.clientHeight;
	}
</script>

<div class={classes}>
	<div class="flex rounded-md shadow-sm">
		{@render left?.()}
		<div class="relative flex flex-grow items-stretch focus-within:z-10">
			<textarea
				bind:this={textarea}
				bind:value
				{...restProps}
				{onblur}
				{id}
				oninput={checkScrollbar}
				onresize={checkScrollbar}
				class:rounded-l-none={!!left}
				class:rounded-r-none={!!right}
				rows={isExpanded ? 4 : rows}
				style:height={!isExpanded ? 'auto' : undefined}
				class={`block w-full rounded-md px-4 py-3
					disabled:cursor-not-allowed disabled:border-violet-200 disabled:bg-gray-100 disabled:text-gray-500
					disabled:placeholder:text-gray-400 invalid:[&:not(:focus)]:[&:not(:placeholder-shown)]:border-red-600
					${inputClasses}`}
			></textarea>
			<button
				type="button"
				onclick={() => (isExpanded = !isExpanded)}
				class="{isExpanded ? 'top-2.5' : 'top-1/2 -translate-y-1/2'} {hasScrollbar
					? 'right-5'
					: 'right-2'} absolute rounded-md bg-violet-100 p-1 text-violet-500 transition-colors"
			>
				{#if isExpanded}
					<IconCollapse class="size-5" />
				{:else}
					<IconExpand class="size-5" />
				{/if}
			</button>
		</div>
		{@render right?.()}
	</div>
	{#if error}
		<span class="text-sm text-red-600">{error}</span>
	{/if}
</div>
